"use client";

const BACKEND_URL = process.env.NEXT_PUBLIC_NEW_BACKEND_URL || "";

// V1.5 (2026-04-30): in addition to firing the server-side click beacon, we
// also persist the clicked dealId in `ft_clicked_deals` cookie. The server
// reads this on listing pages to bypass the V1.5 frequency cap — a deal
// that's been clicked stays pinned even after seenCount > 5.
const CLICKED_COOKIE_NAME = "ft_clicked_deals";
const CLICKED_COOKIE_MAX_AGE_SECONDS = 21 * 24 * 60 * 60;
const CLICKED_COOKIE_MAX_IDS = 20;

function buildBackendUrl(pathname) {
  if (!BACKEND_URL) return "";
  return `${String(BACKEND_URL).replace(/\/+$/, "")}${pathname}`;
}

function sendJsonBeacon(url, payload) {
  if (!url) return;

  const body = JSON.stringify(payload);

  if (typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function") {
    const sent = navigator.sendBeacon(
      url,
      new Blob([body], { type: "application/json" }),
    );
    if (sent) return;
  }

  fetch(url, {
    method: "POST",
    body,
    headers: { "Content-Type": "application/json" },
    keepalive: true,
  }).catch(() => {});
}

function readCookie(name) {
  if (typeof document === "undefined") return "";
  const match = document.cookie
    .split("; ")
    .find((cookie) => cookie.startsWith(`${name}=`));
  return match ? decodeURIComponent(match.split("=").slice(1).join("=")) : "";
}

function writeCookie(name, value, maxAgeSeconds) {
  if (typeof document === "undefined") return;
  document.cookie =
    `${name}=${encodeURIComponent(value)};` +
    `max-age=${maxAgeSeconds};path=/;samesite=lax`;
}

function persistClick(dealId) {
  if (typeof document === "undefined") return;
  const existing = readCookie(CLICKED_COOKIE_NAME);
  const current = existing
    .split(",")
    .map((value) => value.trim())
    .filter(Boolean);
  if (current[0] === dealId) return; // Already at top, no rewrite needed.
  const updated = [dealId, ...current.filter((id) => id !== dealId)].slice(
    0,
    CLICKED_COOKIE_MAX_IDS,
  );
  writeCookie(CLICKED_COOKIE_NAME, updated.join(","), CLICKED_COOKIE_MAX_AGE_SECONDS);
}

/** Record a deal-card click: sends a track-click beacon to the BFF (source + position) and writes the deal id to the ft_clicked_deals cookie for personalization. */
export function fireClickBeacon(dealId, source, position) {
  if (dealId == null || !source || position == null) return;
  const normalizedId = String(dealId).trim();
  if (!normalizedId) return;

  const url = buildBackendUrl(
    `/api/v2/deals/${encodeURIComponent(normalizedId)}/track-click`,
  );
  sendJsonBeacon(url, { source, position });
  persistClick(normalizedId);
}
